import React, { FC } from 'react';
import { Button } from '@material-ui/core';
import { CsvBuilder } from 'filefy';
import { useStyles } from './styles';
import { ExportIcon } from '../../../../../components';
import { trackAmplitudeData } from '../../../../../services/amplitudeService';

interface Props {
  exportFileName: string;
  columns: string[];
  exportTableData: string[][];
  isEnabled: boolean;
  reportNameInEn: string;
}

export const ExportCSV: FC<Props> = ({ exportFileName, exportTableData, columns, isEnabled, reportNameInEn }) => {
  const classes = useStyles();
  const capitalizedColumns = () => columns.map((column) => column?.toUpperCase());

  const handleExportCSVClick = () => {
    trackAmplitudeData('partnerPortal_action_report', {
      type: 'ExportExcel',
      report_name: reportNameInEn,
    });
    const builder = new CsvBuilder(`${exportFileName}.csv`);
    builder.setDelimeter(',').setColumns(capitalizedColumns()).addRows(exportTableData).exportFile();
  };

  return <Button className={classes.btn} onClick={handleExportCSVClick} disabled={!isEnabled} startIcon={<ExportIcon />} />;
};
